import request from '@/utils/request'
// 获取大赛荣誉列表
export function getSpecialList(query) {
    return request({
        url: '/xsps/special/list',
        method: 'get',
        params: query
    })
}
// 查询项目列表
export function listActivity(query) {
    return request({
      url: '/xsps/activity/list',
      method: 'get',
      params: query
    })
  }

  // 查询项目详细
export function getActivity(id) {
    return request({
      url: '/xsps/activity/' + id,
      method: 'get'
    })
  }
// 查询大赛专题详细
export function getSpecial(id) {
  return request({
      url: '/xsps/special/' + id,
      method: 'get'
  })
}

// 查询大赛资讯列表
export function listInformation(query) {
  return request({
    url: '/xsps/activity/information/list',
    method: 'get',
    params: query
  })
}

// 查询小分类列表
export function listSmall(query) {
  return request({
    url: '/competitionmaterial/small/list',
    method: 'get',
    params: query
  })
}
// 查询作品列表
export function listWorks(query) {
  return request({
    url: '/xsps/works/list',
    method: 'get',
    params: query
  })
}
//大赛详情
export function activityItemdetails(id) {
  return request({
      url: '/xsps/activity/'+id,
      method: 'get',
  })
}
// 浏览量
export function addPageViews(id) {
  return request({
      url: '/xsps/special/addPageViews?id='+id,
      method: 'get',
  })
}